<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="PaIndexGroupListFilter" :model="PaIndexGroupList" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="名称" prop="formFilter.name">
          <el-input class="filter-item" v-model="PaIndexGroupList.formFilter.name"
            :clearable="true" placeholder="名称"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetPaIndexGroupList">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshPaIndexGroupList(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-form ref="PaIndexGroupList" :model="formData" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col class="table-box gutter-bottom" :span="24">
          <el-table ref="paIndexGroup" :data="PaIndexGroupList.PaIndexGroup.impl.dataList" :size="defaultFormItemSize" @sort-change="PaIndexGroupList.PaIndexGroup.impl.onSortChange"
            header-cell-class-name="table-header-gray"
            highlight-current-row @current-change="PaIndexGroupList.PaIndexGroup.impl.currentRowChange"
          >
            <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="PaIndexGroupList.PaIndexGroup.impl.getTableIndex" />
            <el-table-column label="名称" prop="name">
            </el-table-column>
            <el-table-column label="参数" prop="paramVariable">
            </el-table-column>
            <el-table-column label="指标值" prop="indexValue">
            </el-table-column>
            <el-table-column label="计算公式" prop="evalFormula">
            </el-table-column>
            <el-table-column label="描述" prop="detail">
            </el-table-column>
            <el-table-column label="备注" prop="remark">
            </el-table-column>
          </el-table>
          <el-row type="flex" justify="end" style="margin-top: 10px;">
            <el-pagination
              :total="PaIndexGroupList.PaIndexGroup.impl.totalCount"
              :current-page="PaIndexGroupList.PaIndexGroup.impl.currentPage"
              :page-size="PaIndexGroupList.PaIndexGroup.impl.pageSize"
              :page-sizes="[10, 20, 50, 100]"
              layout="total, prev, pager, next, sizes"
              @current-change="PaIndexGroupList.PaIndexGroup.impl.onCurrentPageChange"
              @size-change="PaIndexGroupList.PaIndexGroup.impl.onPageSizeChange">
            </el-pagination>
          </el-row>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              确定
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaIndexGroupController, DictionaryController } from '@/api';

export default {
  name: 'PaIndexGroupList',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    name: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        PaIndexGroup: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          indexModelId: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sysUser: {
          },
          isDatasourceInit: false
        }
      },
      PaIndexGroupList: {
        formFilter: {
          name: this.name
        },
        formFilterCopy: {
          name: this.name
        },
        PaIndexGroup: {
          impl: new TableWidget(this.loadPaIndexGroupWidgetData, this.loadPaIndexGroupVerify, true, true, 'sort', 1)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    onResetPaIndexGroupList () {
      this.$refs.PaIndexGroupListFilter.resetFields();
      this.refreshPaIndexGroupList(true);
    },
    /**
     * 绩效指标组数据获取函数，返回Promise
     */
    loadPaIndexGroupWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        paIndexGroupDtoFilter: {
          name: this.PaIndexGroupList.formFilterCopy.name
        }
      }
      return new Promise((resolve, reject) => {
        PaIndexGroupController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.PaIndexGroupList.PaIndexGroup.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.PaIndexGroupList.PaIndexGroup.impl.currentRow.id, 'id');
              this.$refs.paIndexGroup.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 绩效指标组数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaIndexGroupVerify () {
      this.PaIndexGroupList.formFilterCopy.name = this.PaIndexGroupList.formFilter.name;
      return true;
    },
    /**
     * 更新薪资组列表
     */
    refreshPaIndexGroupList (reloadData = false) {
      if (reloadData) {
        this.PaIndexGroupList.PaIndexGroup.impl.refreshTable(true, 1);
      } else {
        this.PaIndexGroupList.PaIndexGroup.impl.refreshTable();
      }
      if (!this.PaIndexGroupList.isInit) {
        // 初始化下拉数据
      }
      this.PaIndexGroupList.isInit = true;
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaIndexGroup: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          indexModelId: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sysUser: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshPaIndexGroupList();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.PaIndexGroup = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
